var Constants = {
    googleRecaptchaKey: __GOOGLE_RECAPTHA_KEY__,
    pageCapacity: 20,
    maxDocumentsForEndingWOConfirmation: 100,
    pageInitialOrd: 0,
    npiCode: "2.16.840.1.113883.4.6",

    immunizationAddresses: [
        {name: "Grits", url: "/api/immunizations/grits", method: "POST"}
    ],

    barCodePrefix: "barcode_"

};

module.exports = Constants;


//////////////////
// WEBPACK FOOTER
// ./app/utils/constants.js
// module id = 195
// module chunks = 0